const LIST_QUERY = `
  query ListDevices(
    $searchTerm: String,
    $paginationParams: PaginationInput!) {
    listDevices(
      searchCriteria: $searchTerm,
      pagination: $paginationParams) {
      objects {
        serialNumber
        name
        isBypass
        isOnline
        parentDevice
        type
        firmware
        isFirmwareUpdateRequired
        authenticationMode
        twoPersonAuthTimeout
        twoPersonAuthMode
        configUpdatedAt
        telemetryUpdatedAt
        network {
          wifiEnabled
          wifiSSID
          wifiPassword
          wifiDhcp
          wifiIpAddressV4
          wifiSubnet
          wifiGateway
          wifiStaticDNS
          wifiPrimaryDNS
          wifiSecondaryDNS
          backupWifiSSID
          backupWifiPassword
          backupWifiDhcp
          backupWifiIpAddressV4
          backupWifiSubnet
          backupWifiGateway
          backupWifiStaticDNS
          backupWifiPrimaryDNS
          backupWifiSecondaryDNS
          ethernetEnabled
          dhcp
          ipAddressV4
          subnet
          gateway
          staticDNS
          primaryDNS
          secondaryDNS
          activeWifi
          currentIpAddr
        }
        group {
          uuid
          name
        }
      }
      totalRows
    }
  }
`

const GET_QUERY = `
  query GetDevice(
    $deviceSerial: String) {
    listDevices(
      searchCriteria: $deviceSerial,
      pagination: {
        page: 1,
        perPage: 10,
      }) {
      objects {
        serialNumber
        name
        isBypass
        isOnline
        parentDevice
        type
        firmware
        authenticationMode
        twoPersonAuthTimeout
        twoPersonAuthMode
        configUpdatedAt
        telemetryUpdatedAt
        network {
          wifiEnabled
          wifiSSID
          wifiPassword
          wifiDhcp
          wifiIpAddressV4
          wifiSubnet
          wifiGateway
          wifiStaticDNS
          wifiPrimaryDNS
          wifiSecondaryDNS
          backupWifiSSID
          backupWifiPassword
          backupWifiDhcp
          backupWifiIpAddressV4
          backupWifiSubnet
          backupWifiGateway
          backupWifiStaticDNS
          backupWifiPrimaryDNS
          backupWifiSecondaryDNS
          ethernetEnabled
          dhcp
          ipAddressV4
          subnet
          gateway
          staticDNS
          primaryDNS
          secondaryDNS
          activeWifi
          currentIpAddr
        }
      }
      totalRows
    }
  }
`

function createMutation(data) {
  const {
    serialNumber,
    name,
    isBypass,
    parentDevice,
    type,
    authenticationMode,
    twoPersonAuthTimeout,
    twoPersonAuthMode,
  } = data
  return `
    mutation {
      createDevice(params: {
        parentDevice: "${parentDevice.toLowerCase()}",
        serialNumber: "${serialNumber.toLowerCase()}",
        type: ${type},
        name: "${name}",
        isBypass: ${isBypass},
        authenticationMode: ${authenticationMode},
        twoPersonAuthTimeout: ${twoPersonAuthTimeout}
        twoPersonAuthMode: ${twoPersonAuthMode}
      }) {
        serialNumber,
        name,
        isBypass,
        isOnline
      }
    }
  `
}

function updateMutation(data) {
  const {serialNumber, name, isBypass} = data
  return `
    mutation {
      updateDevice(params: {
        serialNumber: "${serialNumber}",
        name: "${name}",
        isBypass: ${isBypass},
      }) {
        serialNumber
        name
        isBypass
        isOnline
        network {
          wifiEnabled
            wifiSSID
            wifiPassword
            wifiDhcp
            wifiIpAddressV4
            wifiSubnet
            wifiGateway
            wifiStaticDNS
            wifiPrimaryDNS
            wifiSecondaryDNS
            ethernetEnabled
            dhcp
            ipAddressV4
            subnet
            gateway
            staticDNS
            primaryDNS
            secondaryDNS
        }
      }
    }
  `
}


function updateDeviceNameMutation(data) {
  const {serialNumber, name} = data
  return `
    mutation {
      updateDevice(params: {
        serialNumber: "${serialNumber}",
        name: "${name}",
      }) {
        serialNumber
        name
      }
    }
  `
}

function updateEthernetMutation(data) {
  const {serialNumber, name, isBypass, network} = data
  if (network) {
    return `
      mutation {
        updateDevice(params: {
          serialNumber: "${serialNumber}",
          name: "${name}",
          isBypass: ${isBypass},
          network: {
            ethernetEnabled: ${network.ethernetEnabled},
            dhcp: ${network.dhcp},
            ipAddressV4: "${network.ipAddressV4}",
            subnet: "${network.subnet}",
            gateway: "${network.gateway}",
            staticDNS: ${network.staticDNS},
            primaryDNS: "${network.primaryDNS}",
            secondaryDNS: "${network.secondaryDNS}",
          }
        }) {
          serialNumber
          name
          isBypass
          isOnline
          network {
            wifiEnabled
            wifiSSID
            wifiPassword
            wifiDhcp
            wifiIpAddressV4
            wifiSubnet
            wifiGateway
            wifiStaticDNS
            wifiPrimaryDNS
            wifiSecondaryDNS
            ethernetEnabled
            dhcp
            ipAddressV4
            subnet
            gateway
            staticDNS
            primaryDNS
            secondaryDNS
          }
        }
      }
    `
  }
}

function updateWifiMutation(data) {
  const {serialNumber, name, isBypass, network} = data
  if (network) {
    return `
      mutation {
        updateDevice(params: {
          serialNumber: "${serialNumber}",
          name: "${name}",
          isBypass: ${isBypass},
          network: {
            wifiEnabled: ${network.wifiEnabled},
            wifiSSID: "${network.wifiSSID}",
            wifiPassword: "${network.wifiPassword}",
            wifiDhcp: ${network.wifiDhcp},
            wifiIpAddressV4: "${network.wifiIpAddressV4}",
            wifiSubnet: "${network.wifiSubnet}",
            wifiGateway: "${network.wifiGateway}",
            wifiStaticDNS: ${network.wifiStaticDNS},
            wifiPrimaryDNS: "${network.wifiPrimaryDNS}",
            wifiSecondaryDNS: "${network.wifiSecondaryDNS}",
            backupWifiSSID: "${network.backupWifiSSID}",
            backupWifiPassword: "${network.backupWifiPassword}",
            backupWifiDhcp: ${network.backupWifiDhcp},
            backupWifiIpAddressV4: "${network.backupWifiIpAddressV4}",
            backupWifiSubnet: "${network.backupWifiSubnet}",
            backupWifiGateway: "${network.backupWifiGateway}",
            backupWifiStaticDNS: ${network.backupWifiStaticDNS},
            backupWifiPrimaryDNS: "${network.backupWifiPrimaryDNS}",
            backupWifiSecondaryDNS: "${network.backupWifiSecondaryDNS}",
          }
        }) {
          serialNumber
          name
          isBypass
          isOnline
          network {
            wifiEnabled
            wifiSSID
            wifiPassword
            wifiDhcp
            wifiIpAddressV4
            wifiSubnet
            wifiGateway
            wifiStaticDNS
            wifiPrimaryDNS
            wifiSecondaryDNS
            backupWifiSSID
            backupWifiPassword
            backupWifiDhcp
            backupWifiIpAddressV4
            backupWifiSubnet
            backupWifiGateway
            backupWifiStaticDNS
            backupWifiPrimaryDNS
            backupWifiSecondaryDNS
            ethernetEnabled
            dhcp
            ipAddressV4
            subnet
            gateway
            staticDNS
            primaryDNS
            secondaryDNS
          }
        }
      }
    `
  }
}

function updateAuthModeMutation(data) {
  const {serialNumber, authenticationMode, twoPersonAuthTimeout, twoPersonAuthMode} = data
  return `
    mutation {
      updateDevice(params: {
        serialNumber: "${serialNumber}",
        authenticationMode: ${authenticationMode},
        twoPersonAuthTimeout: ${twoPersonAuthTimeout},
        twoPersonAuthMode: ${twoPersonAuthMode},
      }) {
        serialNumber
        name
        isBypass
      }
    }
  `
}

function deleteMutation(macAddress) {
  return `
    mutation {
      deleteDevice(serialNumber: "${macAddress}")
    }
  `
}

function generateOtpMutation(serialNumber) {
  return `
    mutation {
      generateOtp (serialNumber: "${serialNumber}") {
        otp
        secondsRemaining
      }
    }
  `
}

function upgradeFirmwareMutation(serialNumber) {
  return `
    mutation {
      upgradeFirmware (serialNumber: "${serialNumber}")
    }
  `
}

const deviceQueries = {
  methods: {
    async listDevicesQuery(paginationParams, searchTerm) {
      try {
        const result = await this.graphQuery(LIST_QUERY, {paginationParams, searchTerm})
        const {objects: deviceList, totalRows} = result.listDevices
        return {deviceList, totalRows}
      } catch (error) {
        throw new Error(error)
      }
    },
    async getDeviceQuery(deviceSerial) {
      try {
        const result = await this.graphQuery(GET_QUERY, {deviceSerial})
        const {objects: deviceList, totalRows} = result.listDevices

        if (totalRows === 1) {
          return deviceList[0]
        }

        return null
      } catch (error) {
        throw new Error(error)
      }
    },
    async createDeviceMutation(device) {
      try {
        const result = await this.graphQuery(createMutation(device))
        return result.createDevice
      } catch (error) {
        throw new Error(error)
      }
    },
    async updateDeviceMutation(device) {
      try {
        const result = await this.graphQuery(updateMutation(device))
        return result.updateDevice
      } catch (error) {
        throw new Error(error)
      }
    },
    async updateDeviceNameMutation(device) {
      try {
        const result = await this.graphQuery(updateDeviceNameMutation(device))
        return result.updateDevice
      } catch (error) {
        throw new Error(error)
      }
    },
    async updateDeviceWifiMutation(device) {
      try {
        const result = await this.graphQuery(updateWifiMutation(device))
        return result.updateDevice
      } catch (error) {
        throw new Error(error)
      }
    },
    async updateDeviceEthernetMutation(device) {
      try {
        const result = await this.graphQuery(updateEthernetMutation(device))
        return result.updateDevice
      } catch (error) {
        throw new Error(error)
      }
    },
    async updateDeviceAuthModeMutation(device) {
      try {
        const result = await this.graphQuery(updateAuthModeMutation(device))
        return result.updateDevice
      } catch (error) {
        throw new Error(error)
      }
    },
    async deleteDeviceMutation(serialNumber) {
      try {
        const result = await this.graphQuery(deleteMutation(serialNumber))
        return result.deleteDevice
      } catch (error) {
        throw new Error(error)
      }
    },
    async generateOtpMutation(serialNumber) {
      try {
        const result = await this.graphQuery(generateOtpMutation(serialNumber))
        return result.generateOtp
      } catch (error) {
        throw new Error(error)
      }
    },
    async upgradeDeviceFirmwareMutation(serialNumber) {
      try {
        const result = await this.graphQuery(upgradeFirmwareMutation(serialNumber))
        return result.upgradeDeviceFirmware
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}

export default deviceQueries
